import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiUpload } from "../../api/client";
import { ME_QUERY_KEY } from "./useMe";

// POST /kyc/verify (ID front + selfie). The result lands on the scout profile
// (kyc_status / kyc_details), which screens read from /auth/me, so the session
// is refetched once the server has decided.
export const useVerifyKyc = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ frontImage, selfieImage }) => {
      const form = new FormData();
      form.append("front_image", frontImage);
      form.append("selfie_image", selfieImage);
      return apiUpload("/kyc/verify", form);
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ME_QUERY_KEY }),
  });
};
